// Simple client-side CSV export helper (de-CH friendly: semicolon separator + UTF-8 BOM for Excel)
const escapeCell = (value) => {
  const s = value === null || value === undefined ? "" : String(value);
  if (/[";\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
};

// headers: [{ key, label }], rows: array of objects
export const downloadCSV = (filename, headers, rows) => {
  const headerLine = headers.map((h) => escapeCell(h.label)).join(";");
  const dataLines = rows.map((row) =>
    headers.map((h) => escapeCell(typeof h.format === "function" ? h.format(row[h.key], row) : row[h.key])).join(";")
  );
  const csv = "\uFEFF" + [headerLine, ...dataLines].join("\r\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
